import React, { useState } from 'react';


import PopupModal from '@components/PopupModal';
import ImageIcon from '@icon/ImageIcon';
import JsonIcon from '@icon/JsonIcon';
import MarkdownIcon from '@icon/MarkdownIcon';
import useStore from '@store/store';
import {
  chatToMarkdown,
  downloadImg,
  downloadMarkdown,
  // downloadPDF,
  htmlToImg,
} from '@utils/chat';
import downloadFile from '@utils/downloadFile';
import { useTranslation } from 'react-i18next';

const DownloadChat = React.memo(
  ({ saveRef }: { saveRef: React.RefObject<HTMLDivElement> }) => {
    const { t } = useTranslation();
    const [isModalOpen, setIsModalOpen] = useState<boolean>(false);

    const getCurrentChat = () => {
      const state = useStore.getState();
      return state.chats?.[state.currentChatIndex];
    };

    return (
      <>
        <button
          className='btn btn-neutral'
          onClick={() => {
            setIsModalOpen(true);
          }}
        >
          {t('downloadChat')}
        </button>
        {isModalOpen && (
          <PopupModal
            setIsModalOpen={setIsModalOpen}
            title={t('downloadChat') as string}
            cancelButton={false}
          >
            <div className='p-6 border-b border-gray-200 dark:border-gray-600 flex gap-4'>
              <button
                className='btn btn-neutral gap-2'
                onClick={async () => {
                  if (saveRef && saveRef.current) {
                    const imgData = await htmlToImg(saveRef.current);
                    const chat = getCurrentChat();
                    downloadImg(
                      imgData,
                      `${chat?.title.trim() ?? 'download'}.png`
                    );
                  }
                }}
              >
                <ImageIcon />
                Image
              </button>
              {/* <button
                className='btn btn-neutral gap-2'
                onClick={async () => {
                  if (saveRef && saveRef.current) {
                    const imgData = await htmlToImg(saveRef.current);
                    downloadPDF(
                      imgData,
                      useStore.getState().theme,
                      `${
                        useStore
                          .getState()
                          .chats?.[
                            useStore.getState().currentChatIndex
                          ].title.trim() ?? 'download'
                      }.pdf`
                    );
                  }
                }}
              >
                <PdfIcon />
                PDF
              </button> */}
              <button
                className='btn btn-neutral gap-2'
                onClick={async () => {
                  if (saveRef && saveRef.current) {
                    const chat = getCurrentChat();
                    if (chat) {
                      const markdown = chatToMarkdown(chat);
                      downloadMarkdown(markdown, `${chat.title.trim() || 'download'}.md`);
                    }
                  }
                }}
              >
                <MarkdownIcon />
                Markdown
              </button>
              <button
                className='btn btn-neutral gap-2'
                onClick={async () => {
                  const chat = getCurrentChat();
                  if (chat) {
                    downloadFile([chat], chat.title);
                  }
                }}
              >
                <JsonIcon />
                JSON
              </button>
            </div>
          </PopupModal>
        )}
      </>
    );
  }
);

export default DownloadChat;
